import { createAction, props } from "@ngrx/store";
import { VigilantApiDtoRealm } from "./realms.model";

const prefix = "Realms.";

export const SetRealms = createAction(`${prefix}SetRealms`, props<{ realms: VigilantApiDtoRealm[] }>());

export const ResetRealms = createAction(`${prefix}ResetRealms`);

export const AddRealm = createAction(`${prefix}AddRealm`, props<{ realm: VigilantApiDtoRealm }>());

export const AddRealms = createAction(`${prefix}AddRealms`, props<{ realms: VigilantApiDtoRealm[] }>());

export const UpdateRealm = createAction(`${prefix}UpdateRealm`, props<{ realm: VigilantApiDtoRealm }>());

export const UpdateRealms = createAction(`${prefix}UpdateRealms`, props<{ realms: VigilantApiDtoRealm[] }>());

export const DeleteRealm = createAction(`${prefix}DeleteRealm`, props<{ id: number }>());

export const DeleteRealms = createAction(`${prefix}DeleteRealms`, props<{ ids: number[] }>());
